// Recovered compiled webpack factory 67858. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function () {
        return function e(t) {
          if ((0, a.isNextRouterError)(t) || (0, n.isBailoutToCSRError)(t)) throw t;
          t instanceof Error && "cause" in t && e(t.cause);
        };
      },
    }));
  let n = r(24553),
    a = r(5829);
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
